import BookingRoomCard from './BookingRoomCard';

export default BookingRoomCard;
